<template>
  <div class="pt-2 pb-2">
    <v-card>
      <v-text-field
          label="Search Mail"
          solo
          clearable
          :append-icon="searchMenu ? 'arrow_drop_up' : 'arrow_drop_down'"
          prepend-icon="search"
          color="primary"
          flat
          class="ml-3"
          :hide-details="true"
          @click:append="searchMenu = !searchMenu"
          v-model="localOptions.searchText"
          @keyup.enter="search(true)"
          @click:clear="clearFilter"
      ></v-text-field>
    </v-card>
    <v-menu :full-width="true" v-model="searchMenu" left :close-on-content-click="false">
      <div slot="activator" style="width: 100%;"></div>
      <v-card>
        <v-card-title primary-title class="pb-0 mb-0">
          
          <v-list style="width: 100%">
            <v-list-tile>
              <v-text-field
                  label="To:"
                  color="primary"
                  clearable
                  v-model="localOptions.to"
              ></v-text-field>
            </v-list-tile>
            <v-list-tile>
              <v-text-field
                  label="From:"
                  color="primary"
                  clearable
                  v-model="localOptions.from"
              ></v-text-field>
            </v-list-tile>
            <v-list-tile>
              <v-text-field
                  label="Subject:"
                  color="primary"
                  clearable
                  v-model="localOptions.subject"
              ></v-text-field>
            </v-list-tile>
            <v-list-tile>
              <v-text-field
                  label="Body Contains:"
                  color="primary"
                  clearable
                  v-model="localOptions.hasWords"
              ></v-text-field>
            </v-list-tile>
            
            <v-list-tile>
              <v-checkbox
                  label="Has Attachments"
                  v-model="localOptions.hasAttachment"
              ></v-checkbox>
              <v-spacer/>
            </v-list-tile>
          </v-list>
        
        </v-card-title>
        
        <v-card-actions class="pt-0 mt-0">
          <v-btn @click="clearFilter" flat color="primary">
            <v-icon color="primary" left>clear</v-icon>
            <span>Clear</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="() => search(false)" flat color="primary">
            <v-icon color="primary" left>search</v-icon>
            <span>Search</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    searchOptions: Object
  },
  data() {
    return {
      searchMenu: false,
      localOptions: null
    }
  },
  watch: {
    searchOptions: {
      immediate: true,
      deep: true,
      handler(val) {
        this.localOptions = JSON.parse(JSON.stringify(this.searchOptions))
      }
    }
    
  },
  methods: {
    
    search(textOnly) {
      
      let qString = "";
      
      if (!textOnly) {
        if (this.localOptions.hasWords !== '' && this.localOptions.hasWords != null) {
          qString = qString + this.localOptions.hasWords + ' | '
        }
        if (this.localOptions.to !== '' && this.localOptions.to != null) {
          qString = qString + 'to:' + this.localOptions.to + ' '
        }
        if (this.localOptions.from !== '' && this.localOptions.from != null) {
          qString = qString + 'from:' + this.localOptions.from + ' '
        }
        if (this.localOptions.subject !== '' && this.localOptions.subject != null) {
          qString = qString + 'subject:' + this.localOptions.subject + ' '
        }
        if (this.localOptions.noWords !== '' && this.localOptions.noWords != null) {
          qString = qString + '-' + this.localOptions.noWords.split(" ").join(" -") + ' '
        }
        if (this.localOptions.hasAttachment) {
          qString = qString + ' has:attachment'
        }
        if (this.localOptions.starred) {
          qString = qString + ' is:starred'
        }
      } else {
        qString = this.localOptions.searchText;
        this.localOptions.hasWords = this.localOptions.searchText;
      }
      
      this.localOptions.searchText = qString || this.localOptions.searchText
      
      this.$emit('update:searchOptions',
          textOnly
              ? {
                searchText: this.localOptions.searchText,
                from: '',
                to: '',
                subject: '',
                hasWords: '',
                noWords: '',
                hasAttachment: false,
                starred: false
              }
              : JSON.parse(JSON.stringify(this.localOptions))
      );
      
      this.$emit('search');
      
      this.searchMenu = false
    },
    
    clearFilter() {
      this.$emit('update:searchOptions', {
            searchText: '',
            from: '',
            to: '',
            subject: '',
            hasWords: '',
            noWords: '',
            hasAttachment: false,
            starred: false
          }
      );
    },
  }
}
</script>

<style scoped>

</style>
